import * as d3 from 'd3'
export default {
  methods: {

    draw_DataTable(select) {

      let clippedArea = select
      .append('g')
      .attr('id', `CONTENTS_${this.localId}`)
      .attr('transform', `translate(${0}, ${0})`)

      if(this.rawData.length ==0) {
        clippedArea
        .append('text')
        .attr('x',400).attr('y', 50)
        .attr('font-size', 15).attr('fill', '#EC407A').attr('text-anchor', 'middle')
        .text(this.dataSource.ERROR1)

        clippedArea
        .append('text')
        .attr('x',400).attr('y', 63)
        .attr('font-size', 11).attr('fill', '#333').attr('text-anchor', 'middle')
        .text(this.dataSource.ERROR2)

        return
      }

      // clippedArea // background for Wheeling
      // .append('rect')
      // .attr('id', `BG_CONTENTS`)
      // .attr('x', 0).attr('y', 0)
      // .attr('width', this.scroll.viewbox.width).attr('height', this.scroll.content.height)
      // .attr('fill', '#E0E0DF').attr('opacity', 0)

      
      // CONTENTS ------>
      let y_ = 14
      this.dataSet.forEach((d,i)=> {

        let row = clippedArea
        .append('g')
        .attr('transform', `translate(${0}, ${y_})`)
        .attr('cursor', 'default')
        .on('mouseover', ()=> {
          d3.select(`#ROW_${i}_${this.localId}`).transition().duration(50).attr('fill', '#F7F7F7')
        })
        .on('mouseout', ()=> {
          d3.select(`#ROW_${i}_${this.localId}`).transition().duration(150).attr('fill', '#fff')
        })

        row
        .append('rect')
        .attr('id', `ROW_${i}_${this.localId}`)
        .attr('x', 0).attr('y', -12)
        .attr('width', this.header.width).attr('height', 18)
        .attr('fill', '#fff').attr('opacity', 1)

        this.columns.forEach((col,c)=> {
          let value = d[col.code]
          if(col.trim && value.length > col.trim) value = value.substr(0,col.trim) + '...'

          row
          .append('text')
          .attr('x', col.tx).attr('y', 0)
          .attr('font-size', 10).attr('text-anchor', col.align).attr('fill', '#333')
          .text(c==0 ? i+1 : value)
        })
        y_ = y_ + 20
      }) 

      this.scroll.content.height = y_ - 12
      this.set_ScrollValues()
      // d3.select(`#BG_CONTENTS`).attr('height', y_)
    },

  }
}